/* eslint-disable react-hooks/exhaustive-deps */
/**
 * Imagine that we have table less than widget width
 * in this case we can offer customer to upscale table
 */
import React from 'react';
import { useEffect, useState } from 'react';

const getParentWidth = (parentRef: React.RefObject<HTMLDivElement>) => {
  const el = parentRef.current;
  if (el) {
    return el.clientWidth;
  }
  return 0;
};

const useUpscale = (
  totalColumnsWidth: number,
  headerGroups: any,
  dispatch: any,
  containerWidth: number,
  parentRef: React.RefObject<HTMLDivElement>,
  tableKey: string
) => {
  const [upscale, setUpscale] = useState<boolean>(false);

  useEffect(() => {
    const atLeastOneColumn = headerGroups[0];
    const shorterOrLongerThanParent =
      totalColumnsWidth < containerWidth * 0.99 ||
      totalColumnsWidth > containerWidth; // 0.99 is 99% of parent's width
    setUpscale(atLeastOneColumn && shorterOrLongerThanParent);
  }, [totalColumnsWidth, containerWidth]);

  const handleUpscale = () => {
    const ratio = (getParentWidth(parentRef) - 4) / totalColumnsWidth;
    const [group] = headerGroups;
    let updated: any = {};
    group.headers.forEach((header: any) => {
      updated = {
        ...updated,
        [header.id]: header.width * ratio, // math ceil makes it too big and scroll appears
      };
    });
    dispatch({
      type: 'fitMaxWidth',
      payload: updated,
    });
    localStorage.setItem(tableKey, JSON.stringify(updated));
  };

  return {
    upscale,
    handleUpscale,
  };
};

export default useUpscale;
